import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import Jobs from './Jobs';

const JobsPicker = ({ tabResource }) => {
  return pick(tabResource, {
    [fr.relationships.tabData.name]: (
      <Jobs tabDataRelationship={tabResource?.relationship(fr.relationships.tabData.name)} />
    ),
  }, () => null);
};

JobsPicker.propTypes = {
  tabResource: PropTypes.object.isRequired,
};

export default JobsPicker;
